<!-- cookie-notification.component.html -->
@if (!cookieDecisionMade) {
  <div
    class="cookie-banner position-fixed bottom-0 start-0 w-100 bg-dark text-light text-center p-3 border-top border-secondary"
    role="dialog"
    aria-modal="true"
    aria-labelledby="cookie-banner-title"
    tabindex="-1"
  >
    <div id="cookie-banner-title" class="visually-hidden">
      Cookie and analytics consent
    </div>
    <p class="mb-2">
      We use cookies and analytics to improve your experience and our product.
      Do you accept marketing cookies and analytics tracking?
    </p>
    <button
      type="button"
      class="btn btn-primary me-2"
      (click)="acceptCookies()"
      aria-label="Accept marketing cookies and analytics"
    >
      Accept
    </button>
    <button
      type="button"
      class="btn btn-outline-light"
      (click)="declineCookies()"
      aria-label="Decline marketing cookies and analytics"
    >
      Decline
    </button>
  </div>
}
